import(/* webpackMode: "eager" */ "/vercel/path0/src/app/analytics/page.tsx");
